import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line func-names
const LockIcon = function (props) {
  const { color } = props;
  const displayColor = color === undefined || color === '' ? '#fff' : color;
  return (
    <svg
      width='9px'
      height='12px'
      viewBox='0 0 9 12'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g fill={displayColor} fillRule='nonzero'>
          <path d='M0,5.4 L0,12 L9,12 L9,5.4 M0.642857143,5.4 L0.642857143,3.6 C0.642857143,1.62 2.37857143,0 4.5,0 C6.62142857,0 8.35714286,1.62 8.35714286,3.6 L8.35714286,5.4 L7.07142857,5.4 L7.07142857,3.6 C7.07142857,2.28 5.91428571,1.2 4.5,1.2 C3.08571429,1.2 1.92857143,2.28 1.92857143,3.6 L1.92857143,5.4' />
        </g>
      </g>
    </svg>
  );
};

LockIcon.propTypes = {
  color: PropTypes.string,
};

LockIcon.defaultProps = {
  color: '#fff',
};

export default LockIcon;
